import './PageDescription.scss';
import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

export const PageDescription = ({
  title,
  description,
  className,
}: { title: string; description: string; className: string }): ReactElement => (
  <div className={clsx({
    [className]: true,
    'bp-page-description--container': true,
  })}
  >
    <div className="bp-page-description--title">
      <FormattedMessage id={title}/>
    </div>
    <div className="bp-page-description--content">
      <FormattedMessage id={description}/>
    </div>
  </div>
);
